// Module
var code = `<div class="page-item--products">
  <header class="products-header">
    <h2 class="products-title">{{title}}</h2>
    <p class="products-subtitle">{{subtitle}}</p>
  </header>
  <div class="products-grid">
    {{#products}}
    <div class="product-tile">
      <div class="product-media">
        <img class="product-img" alt="{{name}}" src="{{attrImageSrc}}" />
      </div>
      <div class="product-row">
        <div class="product-copy">
          <h3 class="product-name">{{name}}</h3>
          <p class="product-variant">{{variant}}</p>
        </div>
        <p class="product-price">{{price}}</p>
      </div>
    </div>
    {{/products}}
  </div>
</div>
`;
// Exports
module.exports = code;